import { makeStyles, Theme, withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles((theme: Theme) => ({
  select: {
    fontFamily: "DIN",
  },
  blackColor: {
    color: "black",
  },
  placeholderColor: {
    color: "#707070",
  },
  outlinedTextField: {
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#C8C7CC",
    },
  },
  nativeInput: {
    fontFamily: "DIN",
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  goBackParent: {
    position: "absolute",
    cursor: "pointer",
    top: "50%",
    transform:
      "translate3d(0, -50%, 0) rotate(0) skewX(0) skewY(0) scaleX(1) scaleY(1)",
  },
  goBackChild: {
    stroke: "currentColor",
    fontSize: 24,
    color: "white",
    [theme.breakpoints.down(1024)]: {
      color: "rgba(136, 0, 255, 1)",
    },
  },
  rootCheckbox: {
    color: "#07C806",
  },
  checkedCheckbox: {},
  tableContainer: {
    fontFamily: "DIN",
    borderRadius: 6,
    maxHeight: "100%",
  },
  tableHead: {
    color: "#707070",
  },
  emailHead: {
    width: "40%",
  },
  sourceHead: {
    width: "60%",
  },
  avatar: {
    width: 24,
    height: 24,
  },
  withBorderBottom: {
    borderBottom: "1px solid #c8c7cc",
  },
  noBorderBottom: {
    borderBottom: "none",
  },
}));

export const NextButton = withStyles((theme: Theme) => ({
  root: {
    "&:disabled": {
      color: "white",
      backgroundColor: "#707070",
    },
    width: "100%",
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    textTransform: "none",
    borderRadius: 48,
    backgroundColor: "#8800FF",
    color: "#ffffff",
    height: 40,
    shadowBox: "none",
    "&:hover": {
      backgroundColor: "#8800FF",
      color: "#ffffff",
    },
  },
  text: {
    paddingRight: theme.spacing(3),
    paddingLeft: theme.spacing(3),
  },
}))(Button);

export default useStyles;
